import { serviceMaker } from "..";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";
import { encryptData } from "../../utils/AppFunctions";
import { LOGOUT_REASON_ENUM } from "../../utils/AppEnumerations";
import {
  broadcastSessionEnded,
  clearSessionToken,
} from "../../utils/AuthTokenStore";
import { ILoginSessionSelectPayload } from "../../screens/verify-otp/verifyOtpController";
import { ILogoutPayload } from "../../data/AppInterface";

export const LOGOUT = (payload: ILogoutPayload) =>
  serviceMaker(API_ENDPOINTS.logout.url, API_ENDPOINTS.logout.method, {
    payload: encryptData(JSON.stringify(payload)),
  });

export const LOGOUT_CURRENT_SESSION = (reason: LOGOUT_REASON_ENUM) => {
  void LOGOUT({ reason });
  localStorage.clear();
  clearSessionToken();
  broadcastSessionEnded();
};

export const LOG_IN = (payload: { username: string }) =>
  serviceMaker(API_ENDPOINTS.log_in.url, API_ENDPOINTS.log_in.method, {
    payload: encryptData(JSON.stringify(payload)),
  });

export const FORGOT_PASSWORD = (payload: { username: string }) =>
  serviceMaker(
    API_ENDPOINTS.forgot_password.url,
    API_ENDPOINTS.forgot_password.method,
    {
      payload: encryptData(JSON.stringify(payload)),
    }
  );

export const VERIFY_OTP = (payload: { username: string }) =>
  serviceMaker(API_ENDPOINTS.verify_otp.url, API_ENDPOINTS.verify_otp.method, {
    payload: encryptData(JSON.stringify(payload)),
  });

export const SELECT_LOGIN_SESSION = (payload: ILoginSessionSelectPayload) =>
  serviceMaker(
    API_ENDPOINTS.login_session_select.url,
    API_ENDPOINTS.login_session_select.method,
    {
      payload: encryptData(JSON.stringify(payload)),
    }
  );

export const RESEND_OTP = (payload: { username: string }) =>
  serviceMaker(API_ENDPOINTS.resend_otp.url, API_ENDPOINTS.resend_otp.method, {
    payload: encryptData(JSON.stringify(payload)),
  });

export const VERIFY_FORGOT_OTP = (payload: {
  username: string;
  otp?: string;
}) =>
  serviceMaker(
    API_ENDPOINTS.verify_forgot_otp.url,
    API_ENDPOINTS.verify_forgot_otp.method,
    {
      payload: encryptData(JSON.stringify(payload)),
    }
  );

export const RESET_PASSWORD = (payload: {
  new_password: string;
  confirm_password: string;
  token: string;
}) =>
  serviceMaker(
    API_ENDPOINTS.reset_password.url,
    API_ENDPOINTS.reset_password.method,
    {
      payload: encryptData(JSON.stringify(payload)),
    }
  );

export const CHANGE_PASSWORD = (payload: {
  old_password: string;
  new_password: string;
  confirm_password: string;
}) =>
  serviceMaker(
    API_ENDPOINTS.change_password.url,
    API_ENDPOINTS.change_password.method,
    {
      payload: encryptData(JSON.stringify(payload)),
    }
  );
